/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */
import ShowcaseNpvr from './showcase-npvr';

export default ShowcaseNpvr;


// WEBPACK FOOTER //
// ./src/containers/ShowcaseNpvr/index.js